import { useHistory } from "react-router";
import { Browser } from "@capacitor/browser";
import { Promo, PromoSection } from "@core/types";
import { useGetPromosQuery } from "../providers/promo";
import { UseQueryResult } from "@tanstack/react-query";

interface IUsePromoSectionProps extends Omit<UseQueryResult<Promo[] | null, any>, "data"> {
  promos: Promo[];
  isLoading: boolean;
  handlePromoClick: (promo: Promo) => void;
}

export const usePromoSection = (promoSectionProps?: PromoSection): IUsePromoSectionProps => {
  const history = useHistory();
  const { items: promos = [] } = promoSectionProps || {};

  const isPromosQueryEnabled = promos.length === 0;

  const {
    data: fetchedPromos,
    isLoading: isPromosLoading,
    ...rest
  } = useGetPromosQuery({
    enabled: isPromosQueryEnabled,
  });

  const currentPromos: Promo[] = promos.length ? promos : fetchedPromos || [];

  const handlePromoClick = (promo: Promo) => {
    if (promo.link_type === "external" && promo.link_value) {
      Browser.open({ url: promo.link_value });
    } else if (promo.link_type === "internal" && promo.link_value) {
      history.push(`/${promo.link_value}`);
    } else {
      history.push(`/promo/${promo.id}`);
    }
  };

  const isLoading = isPromosQueryEnabled && isPromosLoading;

  return {
    ...rest,
    isLoading,
    handlePromoClick,
    promos: currentPromos,
  };
};
